import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const fail = (fallback) => (e) => toast.error(e?.response?.data?.detail || fallback);

// Workspace Branding (company identity on generated documents). Logo = the workspace letterhead (single asset).
export function useWorkspaceBranding(wid) {
  const [data, setData] = useState(null);
  const [form, setForm] = useState({ company_name: "", accent_color: "", report_footer: "" });
  const [logoUrl, setLogoUrl] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    const { data: d } = await api.get(`/workspaces/${wid}/branding-settings`);
    setData(d);
    setForm({ company_name: d.company_name, accent_color: d.accent_color, report_footer: d.report_footer });
    if (d.logo) {
      try { const r = await api.get(`/workspaces/${wid}/letterhead?v=${Date.now()}`, { responseType: "blob" }); setLogoUrl(URL.createObjectURL(r.data)); } catch { setLogoUrl(null); }
    } else setLogoUrl(null);
  }, [wid]);
  useEffect(() => { if (wid) load().catch(fail("Could not load branding")); }, [wid, load]);

  const save = async () => {
    setSaving(true);
    try { await api.put(`/workspaces/${wid}/branding-settings`, form); toast.success("Workspace branding saved"); await load(); return true; }
    catch (e) { fail("Save failed")(e); return false; }
    finally { setSaving(false); }
  };
  const uploadLogo = async (file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    try { await api.post(`/workspaces/${wid}/letterhead`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Logo uploaded"); await load(); } catch (e) { fail("Upload failed")(e); }
  };
  const removeLogo = async () => { try { await api.delete(`/workspaces/${wid}/letterhead`); toast.success("Logo removed"); await load(); } catch (e) { fail("Remove failed")(e); } };
  return { data, form, setForm, logoUrl, saving, save, uploadLogo, removeLogo };
}
